<template>
<div class="k-page-content">
        <el-tabs v-model="activeName" class="box-eltab">
            <el-tab-pane label="功能管理" name="first">
                <div class="k-page-common">
                    <div class="k-common-header">
                        <div class="k-filter-option k-filter-input" style="margin-bottom:0;">
                            <el-form :inline="true" :model="searchForm" size="mini" ref="searchForm">
                                <el-form-item label="功能名称">
                                    <el-input v-model="searchForm.action_name" placeholder="请填写功能名称" clearable></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="doSearch">查询</el-button>
                                    <el-button type="primary" @click="reset">重置</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div class="k-common-con">
                        <div class="k-table-wrapper">
                            <div class="k-table-toolbar" style="margin-top:0;">
                                <div>
                                    <el-button type="primary" size="mini" @click="addActionOpen">添加功能</el-button>
                                </div>
                            </div>
                            <div class="k-table-con">
                                <el-table
                                    :data="tableData.data"
                                    style="width: 100%"
                                    row-key="id"
                                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                                    border
                                    stripe
                                    ref = "table"
                                    highlight-current-row
                                    @sort-change="sortChange"
                                    :height="tableHeight">
                                <el-table-column
                                        fixed
                                        prop="action_name"
                                        label="功能名称"
                                        min-width="200">
                                </el-table-column>
                                <el-table-column
                                        prop="action_parent"
                                        label="所属父级"
                                        min-width="200">
                                </el-table-column>
                                <el-table-column
                                        prop="action_perm"
                                        label="权限键"
                                        width="200">
                                </el-table-column>
                                <el-table-column
                                        prop="create_time"
                                        label="创建时间"
                                        width="200"
                                        sortable="custom">
                                </el-table-column>
                                <el-table-column
                                        prop="update_time"
                                        label="修改时间"
                                        width="200"
                                        sortable="custom">
                                </el-table-column>
                                <el-table-column
                                        fixed="right"
                                        label="操作"
                                        min-width="100">
                                    <template slot-scope="scope">
                                        <el-button @click="handleTableEditOpen(scope.row)" type="text" :size="size">编辑</el-button>
                                        <el-button @click="handleTableDelete(scope.row)" type="text" :size="size" class="c-danger">
                                            删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-pagination
                            	background
                            	ref="pagination"
                            	@current-change="handleCurrentChange"
                            	:current-page="tableData.page | number"
                            	:page-size="tableData.pagesize | number"
                            	layout="prev, pager, next, total"
                            	:total="tableData.total | number">
                            </el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    <!--添加部门-->
    <el-drawer
        custom-class="k-drawer"
        :visible.sync="addFormVisiable"
        direction="rtl"
		:close-on-press-escape='false'
		:wrapperClosable='false'
        size="40%">
        <el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="110px" v-loading="loading">
            <div class="drawer-header">
                <div class="header-title">
                    <span>添加功能</span>
                    <i class="el-icon-close k-drawer-close" @click="addFormVisiable = false"></i>
                </div>
            </div>
            <div class="drawer-content">
				<el-form-item label="所属父级" prop="action_parent_path">
					<el-cascader
						v-model="addForm.action_parent_path"
					    :options="options.action_options"
					    :props="{ checkStrictly: true, label:'action_name', value:'id' }"
						@change="changeParentPath"
					    clearable></el-cascader>
				</el-form-item>
                <el-form-item label="功能名称" prop="action_name" v-if="addForm.action_parent_path.length < 1">
					<el-select v-model="addForm.action_name" clearable placeholder="请选择功能名称">
						<el-option v-for="item in options.menus_options" :key="item.id" :label="item.menu_name" :value="item.menu_name"></el-option>
					</el-select>
                </el-form-item>
				<el-form-item label="功能名称" prop="action_name" v-else>
				    <el-input v-model="addForm.action_name" placeholder="请填写功能名称" clearable></el-input>
				</el-form-item>
                <el-form-item label="权限键">
                    <el-input v-model="addForm.action_perm" placeholder="请填写功能动作" clearable></el-input>
                </el-form-item>
                <el-form-item label="非ADMIN是否可分配" prop="is_edit">
					<el-radio-group v-model="addForm.is_edit">
						<el-radio label="2">否</el-radio>
						<el-radio label="1">是</el-radio>
					</el-radio-group>
				</el-form-item>
            </div>
            <div class="drawer-footer">
                <el-button type="primary" @click="addAction" :size='size'>提交</el-button>
                <el-button :size='size' @click="addFormVisiable = false">取消</el-button>
            </div>
        </el-form>
    </el-drawer>
    <!--编辑部门-->
    <el-drawer
        custom-class="k-drawer"
        :visible.sync="editFormVisiable"
        direction="rtl"
		:close-on-press-escape='false'
		:wrapperClosable='false'
        size="40%">
        <el-form :model="editForm" ref="editForm" :size="size" :rules="rules.editForm" label-width="110px" v-loading="loading">
            <div class="drawer-header">
                <div class="header-title">
                    <span>编辑功能</span>
                    <i class="el-icon-close k-drawer-close" @click="editFormVisiable = false"></i>
                </div>
            </div>
            <div class="drawer-content">
                <el-form-item label="所属父级" prop="action_parent_path">
                	<el-cascader
                		v-model="editForm.action_parent_path"
                	    :options="options.action_options"
                	    :props="{ checkStrictly: true, label:'action_name', value:'id' }"
                		@change="changeParentPath"
                	    clearable></el-cascader>
                </el-form-item>
                <el-form-item label="功能名称" prop="action_name" v-if="editForm.action_parent_path.length < 1">
                	<el-select v-model="editForm.action_name" clearable placeholder="请选择功能名称">
                		<el-option v-for="item in options.menus_options" :key="item.id" :label="item.menu_name" :value="item.menu_name"></el-option>
                	</el-select>
                </el-form-item>
                <el-form-item label="功能名称" prop="action_name" v-else>
                    <el-input v-model="editForm.action_name" placeholder="请填写功能名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="权限键">
                    <el-input v-model="editForm.action_perm" placeholder="请填写功能动作" clearable></el-input>
                </el-form-item>
                <el-form-item label="非ADMIN是否可分配" prop="is_edit">
					<el-radio-group v-model="editForm.is_edit">
						<el-radio label="2">否</el-radio>
						<el-radio label="1">是</el-radio>
					</el-radio-group>
				</el-form-item>
            </div>
            <div class="drawer-footer">
                <el-button type="primary" @click="handleTableEdit" :size='size'>提交</el-button>
                <el-button :size='size' @click="editFormVisiable = false">取消</el-button>
            </div>
        </el-form>
    </el-drawer>
</div>
</template>
<script>
export default {
  props: ['info'],
  data() {
      return {
          addFormVisiable: false,
          editFormVisiable: false,
          checkSkVisiable: false,
		  loading:false,
          activeName: 'first',
          size:'mini',
          options: {
              menus_options: [],
			  action_options:[]
          },
          searchForm: {
              action_name: '',
          },
          resetSearch: {
              action_name: '',
          },
          addForm: {
              action_name: '',
              action_parent_path: [],
              action_perm: '',
              is_edit:'2'
          },
          editForm: {
              action_name: '',
              action_parent_path: [],
              action_perm: '',
              is_edit:'2'
          },
          rules: {
              addForm: {
                  'action_name': [{
                          required: true,
                          message: '请填写功能名称',
                          trigger: ['change', 'blur']
                      }
                  ],
                  'action_perm': [{
                      max: 50,
					  required: true,
                      message: '请填写正确的权限键，长度不超过 50',
                      trigger: ['blur']
                  }],
                  'is_edit': [
                      {required: true, message: '请选择分配类型', trigger: ['change']}
                  ],
              },
              editForm: {
                  'action_name': [{
                          required: true,
                          message: '请填写功能名称',
                          trigger: ['blur']
                      },
                      {
                          max: 50,
                          message: '请填写正确的功能名称，长度不超过 50',
                          trigger: ['blur']
                      }
                  ],
                  'action_perm': [{
                      max: 50,
					  required: true,
                      message: '请填写正确的权限键，长度不超过 50',
                      trigger: ['blur']
                  }],
                  'is_edit': [
                      {required: true, message: '请选择分配类型', trigger: ['change']}
                  ],
              }
          },
          tableData: {
              total: 0,
              pagesize: 15,
              page: 1,
              data: []
          }
      }
  },
  computed: {
      tableHeight: function () {
          return window.innerHeight - 320;
      }
  },
  mounted: function () {
      this.handleSearch(this.searchForm);
  },
  methods: {
		reset: function () {
		  this.searchForm = this.resetSearch;
		  this.doSearch();
		},
		handleSearch: function (params, page, prop, order) {
		  this.loading = true;
		  var param = Object.assign({}, params);
		  param['page'] = page ? page : 1;
		  param['pagesize'] = this.tableData.pagesize;
		  param['prop'] = prop ? prop : 'id';
		  param['order'] = order ? order : 'desc';
		  this.$api.get('/admin/fyauth/fyauth/actionlist',param).then(res => {
			  if (res.code === 0) {
				  this.tableData = res.data;
			  } else {
				 this.$message.error(res.msg);
			  }
			  this.loading = false
		  })
		},
		// 执行查询
		doSearch() {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset() {
			this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
			this.doSearch();
		},
		// 排序
		sortChange(e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
			  order = 'asc';
			} else if (e.order == 'descending') {
			  order = 'desc';
			} else {
			  prop = this.resetSearch.prop;
			  order = this.resetSearch.order;
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange(val) {
			this.handleSearch(this.searchForm, val);
		},
		// 添加功能弹窗
		addActionOpen(){
			this.addForm = {
				action_name: '',
				action_parent_path: [],
				action_perm: '',
                is_edit:'2'
			}
			this.getActionOption()
			this.getMenusOption()
			this.addFormVisiable = true;
		},
		// 添加功能
		addAction() {
		  this.$refs['addForm'].validate(function (valid) {
			  if (valid) {
				  this.loading = true;
				  this.$api.post('/admin/fyauth/fyauth/ctact',this.addForm).then(res => {
					  if (res.code === 0) {
						  // 重新加载表格
						  this.handleSearch();
						  this.$message({
							  showClose: true,
							  message: '添加功能成功！',
							  type: 'success'
						  });
						  this.addFormVisiable = false;
					  } else {
						  this.$message.error(res.msg);
					  }
					  this.loading = false
				  })

			  } else {
				  this.$message({
					  showClose: true,
					  message: '请填写正确的信息！',
					  type: 'warning'
				  });
			  }
		  }.bind(this));
		},
		//获取菜单下拉
		getMenusOption(id){
			this.$api.get('/admin/fyauth/fyauth/downList',{id:id ? id : ''}).then(res => {
				if (res.code === 0) {
				  this.options.menus_options = res.data;
				} else {
				  this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//获取功能下拉
		getActionOption(id){
			this.$api.get('/admin/fyauth/fyauth/actionDownList',{id:id ? id : ''}).then(res => {
				if (res.code === 0) {
				  this.options.action_options = res.data;
				} else {
				  this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		// 打开编辑部门弹窗
		handleTableEditOpen(row) {
			this.getMenusOption(row.id)
			this.getActionOption(row.id)
			this.$api.get('/admin/fyauth/fyauth/actionInfo',{id:row.id}).then(res => {
				  if (res.code === 0) {
					  this.editForm = res.data
					  this.editFormVisiable = true;
				  } else {
					  this.$message.error(res.msg);
				  }
				  this.loading = false
			})
		},
		// 编辑部门
		handleTableEdit() {
		  this.$refs['editForm'].validate(function (valid) {
			  if (valid) {
				  this.loading = true;
				  this.$api.put('/admin/fyauth/fyauth/editact',this.editForm).then(res => {
					  if (res.code === 0) {
						  // 重新加载表格
						  this.handleSearch();
						  this.$message({
							  showClose: true,
							  message: '功能信息修改成功！',
							  type: 'success'
						  });
						  this.editFormVisiable = false;
					  } else {
						  this.$message.error(res.msg);
					  }
					  this.loading = false
				  })
			  }
		  }.bind(this));
		},
		// 删除部门
		handleTableDelete(row) {
		  this.$confirm('此操作将永久删除该功能, 是否继续?', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
		  }).then(function() {
			  this.loading = true;
			  this.$api.delete('/admin/fyauth/fyauth/delAction', {id:row.id}).then(res => {
				  if (res.code === 0) {
					  var data = this.tableData.data;
					  data.forEach(function (item, index) {
						  if (item.id == row.id) {
							  this.$delete(data, index);
						  } else if (item.children) {
							  item.children.forEach(function (value, key) {
								  if (value.id == row.id) {
									  this.$delete(item.children, key);
								  }
							  }.bind(this));
						  }
					  }.bind(this));
					  this.$message({
						  showClose: true,
						  message: '该功能已成功删除！',
						  type: 'success'
					  });
				  } else {
					  this.$message.error(res.msg);
				  }
				  this.loading = false
			  })
		  }.bind(this))
		},
		changeParentPath(){
			this.addForm.action_name = ''
		}
  }
}
</script>